/*
Sohel  12/19/2022 3075154998 Added data manager record screen Stepper
Sohel  12/29/2022 3075154998 Added Export Manager Screen
Sohel 01/31/2023 3075154998 label changes
Sohel 01/08/2023 2701335619 Implemented Usage Functionality
Akhila 06/08/2023 2701335619 title label placeholder name change
Sohel 06/10/2023 2701335619 Fixed Search Title Issue
Phanee 08/03/2023 2701335619 Fixed dashboard data disable issue
*/
import React, {useState, useContext} from 'react';
import LandingPage from '../../../LandingPage';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import AddExportManagerRecord from './../DataManagerRecord/AddDataManagerRecord';
import SearchExportManagerRecord from './SearchExportManagerRecord';
import DataManagerRecordUsage from './../DataManagerRecord/DataManagerRecordUsage';
import {useSelector} from 'react-redux';
import {EXPORT_DATA, IMPORT_DATA} from '../../../../constants/ReusableRoleAccess';
function DataManagerRecord() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const exportTemplateRecord =
    location.pathname === '/frameworks/export-template-record' ? true : false;

  const classes = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [editExisting, setEditExisting] = useState(false);
  const [dataManagerRecordData, setDataManagerRecordData] = useState({});

  const {roleData} = useSelector(({role}) => role);

  const dmTempRecordAccess = exportTemplateRecord ?
    roleData?.window?.[EXPORT_DATA]?.['ETMPR'] :
    roleData?.window?.[IMPORT_DATA]?.['ITMPR'];

  const tabLabels = ['Export Template Records'];
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={0}
        handleTabChange={()=>{}}
        allAntTabs={tabLabels}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 && (
                  <SearchExportManagerRecord
                    setValue={setValue}
                    setDataManagerRecordData={setDataManagerRecordData}
                    setEditExisting={setEditExisting}
                    dmTempRecordAccess={dmTempRecordAccess}
                    type="Export"
                  />
                )}
                {value === 1 && (
                  <AddExportManagerRecord
                    setValue={setValue}
                    exportManagerRecord={true}
                    editExisting={editExisting}
                    dmTempRecordAccess={dmTempRecordAccess}
                  />
                )}
                {value === 2 && (
                  <DataManagerRecordUsage
                    setValue={setValue}
                    dataManagerRecordData={dataManagerRecordData}
                    exportManagerRecord={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default DataManagerRecord;
